import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ArrowUpOutlinedSvg from "@ant-design/icons-svg/es/asn/ArrowUpOutlined";
import AntdIcon from "../components/AntdIcon";
var ArrowUpOutlined = function ArrowUpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ArrowUpOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ArrowUpOutlined.displayName = 'ArrowUpOutlined';
}
export default /*#__PURE__*/React.forwardRef(ArrowUpOutlined);